import window from 'global/window';

import {getPrefixedLogger} from '@netx/core-next/instance/logger';
const logger = getPrefixedLogger('core/utils/setGlobal');

/**
 * We have a global namespace issue in our app.\
 * With old backbone code we have a lot of circular dependencies that are only
 * resolved by using a global namespace at the moment. There is also just a lot
 * of old code expecting to find things in the global namespace.\
 * Rather than have all of that code just use `window.Netx` directly, we can
 * use this function to set the global namespace in a more controlled way - while
 * also logging its usage.
 * @param object An object or an function that returns an object to add to the global namespace
 *
 * @example
 * // adding to/overriding on the global namespace
 * setGlobal({
 * 	cms: {
 * 		portal: 'foo',
 * 	}
 * }); // accessible at Netx.cms
 *
 * @example
 * // merging with an existing object
 * setGlobal((Netx) => ({
 * 	cms: {
 * 		...Netx.cms,
 * 		portal: 'foo',
 *	},
 * }));
 */
export const setGlobal = (object: Object | ((object: Object) => Object)) => {
	// the netx global object may not have been setup yet
	const Netx = (window.Netx = window.Netx || {});
	const obj = typeof object === 'function' ? object(Netx) : object;
	logger.silly('adding to `Netx` namespace >', Object.keys(obj).join(', '));
	Object.assign(Netx, obj);
};

export default setGlobal;
